import { requestsAPI } from '../../api';
import { processRequest } from '@/utils/helpers';
const state = {
    createRequest: {
        step: 0,
        requestId: null,
        requestNumber: null,
        requestInformation: {
            requestType: null,
            category: null,
            subCategory: null,
            isFastTrack: false,
            title: '',
            businessReason: '',
        },
        accountingDetails: {
            vendor: '',
            vendorName: '',
            companyCode: '',
            requestDate: '',
            dueDate: '',
            postingDate: '',
            taxCode: '',
            documentType: '',
            amount: '',
            currency: '',
            invoiceReference: '',
        },
        paymentInformation: {
            bankAccount: '',
            bankReference: '',
            paymentMethod: '',
            specialHandling: '',
            boletoNumber: '',
            guiaNumberBarcode: '',
            guiaNumberNoCode: '',
            italyF24: '',
            italyMav: '',
            dinNumber: '',
            lineaDeCaptura: '',
            isr: '',
            bankDetails: '',
            pagoReferenciado: '',
            taxType: '',
        },
        otherPaymentInformation: {},
        LineEntries: [],
        calculateTax: null,
        inheritTaxCode: null,
    },
    requests: [],
    table: {
        options: {},
        totalRequests: 0,
    },
    filterOptions: {
        category: [],
        subCategory: [],
        companyCode: [],
        vendor: [],
        vendorName: [],
        paymentType: [],
        requestType: [],
        createdBy: [],
        status: [],
    },
};

const getters = {};

const mutations = {
    setCreateRequestStep(state, step) {
        state.createRequest.step = step;
    },
    setCreateRequestRequestId(state, requestId) {
        state.createRequest.requestId = requestId;
    },
    setCreateRequestRequestNumber(state, requestNumber) {
        state.createRequest.requestNumber = requestNumber;
    },
    setTotalRequests(state, totalRequests) {
        state.table.totalRequests = totalRequests;
    },
    setCreateRequestInformation(state, requestInformation) {
        state.createRequest.requestInformation = requestInformation;
    },
    setCreateRequestaccountingDetails(state, accountingDetails) {
        state.createRequest.accountingDetails = accountingDetails;
    },
    setCreateRequestpaymentInformation(state, paymentInformation) {
        state.createRequest.paymentInformation = paymentInformation;
    },
    setCreateRequestLineEntries(state, LineEntries) {
        state.createRequest.LineEntries = LineEntries;
    },
    clearCreateRequest(state) {
        state.createRequest = {
            step: 0,
            requestId: null,
            requestNumber: null,
            requestInformation: {
                requestType: null,
                category: null,
                subCategory: null,
                isFastTrack: false,
                title: '',
                businessReason: '',
            },
            accountingDetails: {
                vendor: '',
                vendorName: '',
                companyCode: '',
                requestDate: '',
                dueDate: '',
                postingDate: '',
                taxCode: '',
                documentType: '',
                amount: '',
                currency: '',
                invoiceReference: '',
            },
            paymentInformation: {
                bankAccount: '',
                bankReference: '',
                paymentMethod: '',
                specialHandling: '',
                boletoNumber: '',
                guiaNumberBarcode: '',
                guiaNumberNoCode: '',
                italyF24: '',
                italyMav: '',
                dinNumber: '',
                lineaDeCaptura: '',
                isr: '',
                bankDetails: '',
                pagoReferenciado: '',
                taxType: '',
            },
            otherPaymentInformation: {},
            LineEntries: [],
            calculateTax: null,
            inheritTaxCode: null,
        };
    },
    setFilterOptions(state, options) {
        state.filterOptions = options;
    },
    setCalculateTax(state, calculateTax) {
        state.createRequest.calculateTax = calculateTax;
    },
    setInheritTaxCode(state, inheritTaxCode) {
        state.createRequest.inheritTaxCode = inheritTaxCode;
    },
    setOtherPaymentInformation(state, value) {
        state.createRequest.otherPaymentInformation = value;
    },
    setTaxCode(state, taxCode) {
        state.createRequest.accountingDetails.taxCode = taxCode;
    },
};

const actions = {
    async getAllRequests(_, params) {
        const response = await requestsAPI.getAllRequestsAPI(params);
        return {
            items: response.data._embedded.requests,
            total: response.data['bz:total_records'] || 0,
            totalPages: response.data['bz:total_pages'] || 0,
        };
    },
    async getRequestById({ commit }, { id, forCreate }) {
        const response = await requestsAPI.getRequestByIdAPI(id);
        if (forCreate && response) {
            const data = processRequest(await response.data);
            commit('setCreateRequestRequestId', id);
            commit('setCreateRequestRequestNumber', response.data.requestNo);
            commit('setCreateRequestInformation', data.requestInformation);
            commit('setCreateRequestaccountingDetails', data.accountingDetails);
            commit('setCreateRequestpaymentInformation', data.paymentInformation);
            commit('setCalculateTax', data.calculateTax);
            commit('setInheritTaxCode', data.inheritTaxCode);
            commit('setOtherPaymentInformation', data.otherPaymentInformation);
        }
        return response.data;
    },
    async getRequestStep({ commit }, requestId) {
        const requestDetails = await requestsAPI.getRequestByIdAPI(requestId);
        const requestItems = await requestsAPI.getAllRequestItemsAPI(requestId, '?page=0&size=1');

        if (requestDetails.data.requestType === 'OnlineCreditDebit') {
            if (requestItems.data._embedded['line-entry']?.length > 0) {
                commit('setCreateRequestStep', 4);
                return;
            } else if (requestDetails.data.vendor && requestDetails.data.vendor !== '') {
                commit('setCreateRequestStep', 3);
                return;
            } else if (requestDetails.data.requestType) {
                commit('setCreateRequestStep', 2);
                return;
            }
        } else if (requestDetails.data.requestType === 'RequestForm') {
            if (requestItems.data._embedded['line-entry']?.length > 0) {
                commit('setCreateRequestStep', 5);
                return;
            } else if (requestDetails.data.additionalInfo?.bankDetails?.value) {
                commit('setCreateRequestStep', 4);
                return;
            } else if (requestDetails.data.vendor && requestDetails.data.vendor !== '') {
                commit('setCreateRequestStep', 3);
                return;
            } else if (requestDetails.data.requestType) {
                commit('setCreateRequestStep', 2);
                return;
            }
        } else {
            commit('setCreateRequestStep', 0);
            return;
        }
    },
    async createRequestInformation({ commit }, body) {
        const response = await requestsAPI.createRequestInformationAPI(body);
        await commit('setCreateRequestRequestId', response.data.requestId);
        return await response.data.requestId;
    },
    async updateRequestInformation(_, { requestId, body }) {
        const response = await requestsAPI.updateRequestInformationAPI(requestId, body);
        return response.data;
    },
    async addUpdateAccountingInformation(_, { requestId, body }) {
        const response = await requestsAPI.addUpdateAccountingInformationAPI(requestId, body);
        return response.data;
    },
    async addUpdatePaymentInformation(_, { requestId, body }) {
        const response = await requestsAPI.addUpdatePaymentInformationAPI(requestId, body);
        return response.data;
    },
    async getAllRequestItems({ commit }, { requestId, params }) {
        const response = await requestsAPI.getAllRequestItemsAPI(requestId, params);
        commit('setCreateRequestLineEntries', response.data._embedded['line-entry']);
        // commit('setIsGross', response.data._embedded['line-entry'][0]?.isGross || null);
        return { total: response.data['bz:total_records'] || 0, totalPages: response.data['bz:total_pages'] };
    },
    async addRequestItem(_, { requestId, body }) {
        const response = await requestsAPI.addRequestItemAPI(requestId, body);
        return response.data;
    },
    async updateRequestItem(_, { requestId, lineEntryId, body }) {
        const response = await requestsAPI.updateRequestItemAPI(requestId, lineEntryId, body);
        return response.data;
    },
    async uploadRequestItem(_, { requestId, body }) {
        const response = await requestsAPI.uploadRequestItemAPI(requestId, body);
        return response.data;
    },
    async deleteRequestItems(_, { requestId, itemIds }) {
        const response = await requestsAPI.deleteRequestItemAPI(requestId, { itemNos: itemIds });
        return response.data;
    },
    async deleteAllRequestItemsOfRequest(_, requestId) {
        const response = await requestsAPI.deleteAllRequestItemOfRequestAPI(requestId);
        return response.data;
    },
    async attachSupportingDocument(_, { requestId, body, type }) {
        const response = await requestsAPI.attachSupportingDocumentAPI(requestId, body, type);
        return response.data;
    },
    async getAttachmentsOfRequest(_, requestId) {
        const response = await requestsAPI.getAttachmentsOfRequestAPI(requestId);
        return response.data;
    },
    async downloadAttachment(_, attachmentId) {
        const response = await requestsAPI.downloadAttachmentAPI(attachmentId);
        return response.data;
    },
    async deleteAttachment(_, attachmentId) {
        const response = await requestsAPI.deleteAttachmentAPI(attachmentId);
        return response.data;
    },
    async downloadLineEntryTemplate(_, type) {
        const response = await requestsAPI.downloadLineEntryTemplateAPI(type);
        return response.data;
    },
    async getRequestReport(_, params) {
        const response = await requestsAPI.getRequestReportAPI(params);
        return { data: response.data._embedded['request-report'], total: response.data['bz:total_records'] || 0 };
    },
    async downloadRequestReport(_, params) {
        const response = await requestsAPI.downloadRequestReportAPI(params);
        return response.data;
    },
    async submitRequest(_, requestId) {
        const response = await requestsAPI.submitRequestAPI(requestId);
        return response.data;
    },
    async getRequestFilters({ commit }) {
        const response = await requestsAPI.getRequestFiltersAPI();
        commit('setFilterOptions', response.data);
        return response.data;
    },
    async reProcessRequest(_, requestId) {
        const response = await requestsAPI.reProcessRequestAPI(requestId);
        return response.data;
    },
    async reverseRequest(_, data) {
        const response = await requestsAPI.reverseRequestAPI(data.id, data.reason);
        return response.data;
    },
    async forceReverseRequest(_, data) {
        const response = await requestsAPI.forceReverseRequestAPI(data.id, data.reason, data.sapReversalCode);
        return response.data;
    },
    async getRequestKPI() {
        const response = await requestsAPI.getRequestKPIAPI();
        return response.data;
    },
    async getAllowedPaymentInformationFields(_, companyCode) {
        const response = await requestsAPI.getAllowedPaymentInformationFieldsAPI(companyCode);
        return response.data;
    },
    async checkIfApprovedVendor(_, vendor, companyCode) {
        const response = await requestsAPI.checkIfApprovedVendorAPI(vendor, companyCode);
        return response.data;
    },
    async getPaymentInformationDefaultValues(_, companyCode) {
        const response = await requestsAPI.getDefaultValuesOfPaymentInformationAPI(companyCode);
        return response.data;
    },
    async cloneRequest(_, requestId) {
        const response = await requestsAPI.cloneRequestAPI(requestId);
        return response.data;
    },
    async updateTaxInformation({ commit }, data) {
        return await requestsAPI
            .updateTaxInformationAPI(data.requestId, data)
            .then((res) => {
                commit('setCalculateTax', data.calculateTax);
                commit('setInheritTaxCode', data.inheritTaxCode);
                commit('setTaxCode', data.taxCode);
                return res;
            })
            .catch((err) => {
                throw err;
            });
    },
    setTableOptions({ commit }, options) {
        commit('setTableOptions', options);
    },
    setCreateRequestStep({ commit }, step) {
        commit('setCreateRequestStep', step);
    },
    setCreateRequestRequestId({ commit }, requestId) {
        commit('setCreateRequestRequestId', requestId);
    },
    setCreateRequestInformation({ commit }, requestInformation) {
        commit('setCreateRequestInformation', requestInformation);
    },
    setCreateRequestaccountingDetails({ commit }, accountingDetails) {
        commit('setCreateRequestaccountingDetails', accountingDetails);
    },
    setCreateRequestpaymentInformation({ commit }, paymentInformation) {
        commit('setCreateRequestpaymentInformation', paymentInformation);
    },
    setCreateRequestLineEntries({ commit }, LineEntries) {
        commit('setCreateRequestLineEntries', LineEntries);
    },
    async downloadBulkRequestTemplate1() {
        const response = await requestsAPI.downloadExcelType1API();
        return response.data;
    },
    async uploadBulkRequest1(_, payload) {
        const response = await requestsAPI.uploadExcelType1API(payload.formData);
        return response.data;
    },
    async downloadBulkRequestTemplate2() {
        const response = await requestsAPI.downloadExcelType2API();
        return response.data;
    },
    async uploadBulkRequest2(_, payload) {
        const response = await requestsAPI.uploadExcelType2API(payload.formData);
        return response.data;
    },
    async syncRequest(_, requestId) {
        const response = await requestsAPI.syncRequestAPI(requestId);
        return response.data;
    },
    async checkLineItemsBalance(_, requestId) {
        const response = await requestsAPI.checkLineItemsBalance(requestId);
        return response.data;
    },
    async submitPaymentProof(_, data) {
        const body = {
            comments: data.comments,
            taskId: data.taskId,
            isGroupTask: data.isGroupTask,
            isFilesAttached: data.isFilesAttached,
        };
        const response = await requestsAPI.submitProofAPI(data.requestId, body);
        return response.data;
    },
    async submitPaymentProofWithoutTask(_, data) {
        const body = {
            comments: data.comments,
            isFilesAttached: data.isFilesAttached,
        };
        const response = await requestsAPI.submitProofWithoutTaskAPI(data.requestId, body);
        return response.data;
    },
    async requestProofOfPayment(_, data) {
        const body = {
            assignee: data.assignee,
        };
        const response = await requestsAPI.requestProofOfPaymentAPI(data.requestId, body);
        return response.data;
    },
    async deleteRequest(_, requestId) {
        const response = await requestsAPI.deleteRequestAPI(requestId);
        return response.data;
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
